import cloneDeep from 'lodash/cloneDeep';

class SuggestedProduct {
  constructor({id, dealerId, productCategory, product}) {
    this.dealerId = dealerId;
    this.id = id;
    this.product = product;
    this.productCategory = productCategory;
  }

  clone() {
    return cloneDeep(this);
  }

  toApiFormat() {
    return {
      DealerID: this.dealerId,
      ID: this.id,
      Product: this.product,
      ProductCategory: this.productCategory,
    };
  }

  static fromApiFormat(api) {
    return new SuggestedProduct({
      dealerId: api.DealerID,
      id: api.ID,
      product: api.Product,
      productCategory: api.ProductCategory,
    });
  }
}

export default SuggestedProduct;
